import { createContext, useContext } from "react";
import { GalleryMedia } from "../types/galleryTypes";

export const GalleryContext = createContext<GalleryMedia | undefined>(
  undefined
);

export function useGalleryContext() {
  const galleryMedia = useContext(GalleryContext);

  if (galleryMedia === undefined) {
    throw new Error("useGalleryContext must be used with a GalleryContext");
  }

  return galleryMedia;
}
